import React, { ReactNode } from 'react'
import { Button } from '@resurs/midas-react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getText } from '../../../internal/TextLabels'
import { classNames } from '../../../util/helpers'

import styles from './DefaultEmptyInfoBox.module.scss'

const getTitleValue = (value: ReactNode) => {
  if (typeof value === 'string') {
    return value
  }
  if (typeof value === 'number') {
    return value.toString()
  }
  return ''
}

interface DefaultEmptyInfoBoxProps {
  label: string
  value?: ReactNode
  valueStrikeThrough?: boolean
  faIcon?: IconProp
  additionalStyles?: React.CSSProperties[]
  onIconClick?: () => void
  svgIcon?: string
  svgIconAltText?: string
}

const DefaultEmptyInfoBox: React.FC<DefaultEmptyInfoBoxProps> = ({
  label,
  value,
  valueStrikeThrough = false,
  faIcon,
  additionalStyles = [],
  onIconClick = () => {},
  svgIcon,
  svgIconAltText,
}) => (
  <div className={styles.info} style={Object.assign({}, ...additionalStyles)}>
    <div className={classNames(styles.textOverflow)}>
      <div
        title={getText(label)}
        className={`${styles.textOverflow} ${styles.label}`}
      >{`${getText(label)}: `}</div>
      <div
        title={getTitleValue(value)}
        className={styles.value}
        style={{
          ...(valueStrikeThrough ? { textDecoration: 'line-through' } : {}),
        }}
      >
        {value || '\u00A0'}
      </div>
    </div>
    {(faIcon || svgIcon) && (
      <div className={styles.iconContainer}>
        <div className={styles.iconCircleHover}>
          <Button size="large" type="link" onClick={onIconClick}>
            {faIcon && (
              <FontAwesomeIcon className={styles.faIcon} icon={faIcon} />
            )}
            {svgIcon && (
              <img
                className={styles.svgIcon}
                src={svgIcon}
                alt={svgIconAltText}
                title={svgIconAltText}
              />
            )}
          </Button>
        </div>
      </div>
    )}
  </div>
)

export default DefaultEmptyInfoBox
